import React from 'react';
import styled from 'styled-components';
const Icon = styled.svg`
  width: 25px;
  height: 25px;
`;
export default (() => /*#__PURE__*/React.createElement(Icon, {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "25",
  "aria-label": "account"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-17, -93)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(14, 89)"
}, /*#__PURE__*/React.createElement("rect", {
  x: "3",
  y: "4",
  fill: "none",
  width: "25",
  height: "25"
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  cx: "14.5",
  cy: "12.8",
  rx: "3.8",
  ry: "3.8"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  d: "M21.9,24c0-3.9-3.3-7.1-7.5-7.1S7,20.1,7,24"
})))));